var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.additionalAttributes.recording_url)?_c('div',[_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":this.additionalAttributes.recording_url,"type":"audio/mp3"}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }